import React from 'react';
import { Link } from 'react-router-dom';

function scrollToTop() {
    window.scrollTo(0, 0);
}

function Footer() {
    return (
        <div>
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-sm-4 col-xs-12 mobile-view">
                            <div className="widget clearfix">
                                <div className="widget-title">
                                    {/* <img src="images/logos/logo-2.png" alt="" /> */}
                                    {/* <img src="images/logos/logo-3.png" alt="" /> */}
                                </div>
                                {/* <p> Integer rutrum ligula eu dignissim laoreet. Pellentesque venenatis nibh sed tellus faucibus bibendum. Sed fermentum est vitae rhoncus molestie. Cum sociis natoque penatibus et magnis dis montes.</p>
                            <p>Sed fermentum est vitae rhoncus molestie. Cum sociis natoque penatibus et magnis dis montes.</p> */}
                                {/* <img src="images/logos/logo-4.png" class="footer-logo" alt="" /> */}
                                <img src="images/apple-touch-icon-tr.png" alt="logo" style={{ width: '100px', height: '77px' }} />
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-4 col-xs-12">
                            <div className="widget clearfix">
                                <div className="widget-title">
                                    {/* <h3>Pages</h3> */}
                                    <h3>Links</h3>
                                </div>

                                <ul className="footer-links hov">
                                    <li>
                                        {/* <a href="#">Home <span className="icon icon-arrow-right2"></span></a> */}
                                        {/* <Link to="/" onClick={scrollToTop}>Home<span className="icon icon-arrow-right2"></span></Link> */}
                                        <Link to="/" onClick={scrollToTop}>Home<span className="icon"></span></Link>
                                    </li>
                                    <li>
                                        {/* <a href="#">Blog <span className="icon icon-arrow-right2"></span></a> */}
                                        <Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy<span className="icon"></span></Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/terms" onClick={scrollToTop}>Terms & Conditions<span className="icon"></span></Link>
                                    </li> */}
                                    <li>
                                        <a
                                            href="https://web.enin.io/"
                                            className="enin-login"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Enin Login
                                        </a>
                                    </li>
                                    {/* <li><a href="#">Pricing <span className="icon icon-arrow-right2"></span></a></li> */}
                                    <li>
                                        {/* <a href="#">About <span className="icon icon-arrow-right2"></span></a> */}
                                        <Link to="/about" onClick={scrollToTop}>About<span className="icon"></span></Link>
                                    </li>
                                    {/* <li><a href="#">Faq <span className="icon icon-arrow-right2"></span></a></li> */}
                                    <li>
                                        {/* <a href="#">Contact <span className="icon icon-arrow-right2"></span></a> */}
                                        <Link to="/contact" onClick={scrollToTop}>Contact Us<span className="icon"></span></Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-4 col-xs-12">
                            {/* <div className="footer-distributed widget clearfix"> */}
                            <div className="widget clearfix">
                                <div className="widget-title">
                                    {/* <h3>Subscribe</h3> */}
                                    <h3>Address</h3>
                                    {/* <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which one know this tricks.</p> */}
                                    {/* <address>Piggycoins Transaction Services</address> */}
                                    <p style={{ margin: '20px 0 0 0' }}>Piggycoins Transaction Services <br />Kharadi, Pune 411014<br />MH, India.<br />
                                    
                                    Email : ma@mypiggycoins.com <br />
                                    D&B D-U-N-S Number: 86-032-5945 <br/>
                                    MSME Certifcate  Number: UDYAM-MH-26-1144134</p>
                                </div>

                                {/* <div className="footer-right">
                                <form method="get" action="#">
                                    <input placeholder="Subscribe our newsletter.." name="search">
                                    <i className="fa fa-envelope-o"></i>
                                </form>
                            </div>                         */}
                            </div>
                        </div>
                    </div>
                </div>
            </footer>


            <div class="copyrights">
                <div class="container">
                    <div class="footer-distributed">

                        <div class="footer-left">
                            <p class="footer-company-name">
                                All Rights Reserved. &copy; {new Date().getFullYear()}
                                  <a href="/">  Powered by myPiggycoins</a> <img src="images/power_by.png" alt="logo" style={{ width: '19px', height: '19px' }}/>
                            </p>
                        </div>

                        <div class="footer-right">
                            <Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy<span className="icon"></span></Link> | 
                            <Link to="/terms" onClick={scrollToTop}>Terms & Conditions<span className="icon"></span></Link>
                            
                        </div>

                    </div>
                </div>
            </div>


            <a href="/" id="scroll-to-top" className="dmtop global-radius"><i className="fa fa-angle-up"></i></a>
        </div>
    );
}

// function Footer() {
//     return (
//         <footer className="footer">
//             <div className="container">
//                 <div className="row">
//                     <div className="col-md-4 col-sm-4 col-xs-12">
//                         <div className="widget clearfix">
//                             <div className="widget-title">
//                                 <img src="images/logos/logo-2.png" alt="Logo" />
//                             </div>
//                             <p>Integer rutrum ligula eu dignissim laoreet. Pellentesque venenatis nibh sed tellus faucibus bibendum. Sed fermentum est vitae rhoncus molestie. Cum sociis natoque penatibus et magnis dis montes.</p>
//                             <p>Sed fermentum est vitae rhoncus molestie. Cum sociis natoque penatibus et magnis dis montes.</p>
//                         </div>
//                     </div>

//                     <div className="col-md-4 col-sm-4 col-xs-12">
//                         <div className="widget clearfix">
//                             <div className="widget-title">
//                                 <h3>Pages</h3>
//                             </div>

//                             <ul className="footer-links hov">
//                                 <li><a href="#">Home <span className="icon icon-arrow-right2"></span></a></li>
//                                 <li><a href="#">Blog <span className="icon icon-arrow-right2"></span></a></li>
//                                 <li><a href="#">Pricing <span className="icon icon-arrow-right2"></span></a></li>
//                                 <li><a href="#">About <span className="icon icon-arrow-right2"></span></a></li>
//                                 <li><a href="#">Faq <span className="icon icon-arrow-right2"></span></a></li>
//                                 <li><a href="#">Contact <span className="icon icon-arrow-right2"></span></a></li>
//                             </ul>
//                         </div>
//                     </div>

//                     <div className="col-md-4 col-sm-4 col-xs-12">
//                         <div className="footer-distributed widget clearfix">
//                             <div className="widget-title">
//                                 <h3>Subscribe</h3>
//                                 <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which one knows these tricks.</p>
//                             </div>

//                             {/* <div className="footer-right">
//                                 <form method="get" action="#">
//                                     <input placeholder="Subscribe our newsletter.." name="search" />
//                                     <i className="fa fa-envelope-o"></i>
//                                 </form>
//                             </div> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="copyrights">
//                 <div className="container">
//                     <div className="footer-distributed">
//                         <div className="footer-left">
//                             <p className="footer-company-name">All Rights Reserved. &copy; 2018 <a href="/">GoodWEB</a> Design By :
//                             <a href="https://html.design/">html design</a></p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <a href="/" id="scroll-to-top" className="dmtop global-radius"><i className="fa fa-angle-up"></i></a>
//         </footer>
//     );
// }
export default Footer;